import React, { useState, useRef } from "react";
import { getYouTubeVideoId } from "../utils/helpers";
import { ArrowLeftIcon, ArrowRightIcon, PlayIcon } from "./Icons";
import { InlineShareButtons } from "./ShareButton";
import ReelPlayerModal from "./ReelPlayerModal";

const ReelsSection = ({ reels, headings, lang }) => {
  const [selectedReel, setSelectedReel] = useState(null);
  const scrollContainerRef = useRef(null);

  if (!reels || reels.length === 0) return null;

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = scrollContainerRef.current.offsetWidth * 0.8;
      scrollContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="container mx-auto px-4 pt-4 pb-8">
      <h2 className="text-2xl font-bold mb-4 border-b-2 border-red-600 pb-2">
        {headings.reels}
      </h2>
      <div className="relative">
        <button
          onClick={() => scroll("left")}
          className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white rounded-full p-2 shadow-lg transition-transform transform hover:scale-110 -ml-4"
        >
          <ArrowLeftIcon />
        </button>
        <div
          ref={scrollContainerRef}
          className="flex space-x-4 overflow-x-auto pb-4 scrollbar-hide"
        >
          {reels.map((reel) => {
            const videoId = getYouTubeVideoId(reel.shortVideo);
            if (!videoId) return null;
            return (
              <div
                key={reel.id}
                className="flex-shrink-0 w-48 group cursor-pointer"
                onClick={() => setSelectedReel(reel)}
              >
                <div className="relative rounded-lg overflow-hidden h-72 bg-gray-700">
                  <img
                    src={`https://img.youtube.com/vi/${videoId}/mqdefault.jpg`}
                    alt={reel.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-black/40"></div>
                  <div className="absolute top-2 left-2 text-white font-bold text-sm bg-black/50 px-2 py-1 rounded">
                    Shorts
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <PlayIcon />
                  </div>
                </div>
                <h4 className="mt-2 font-semibold text-sm h-10 overflow-hidden text-ellipsis line-clamp-2">
                  {reel.title}
                </h4>
                <div className="flex justify-end" onClick={(e) => e.stopPropagation()}>
                  <InlineShareButtons
                    url={`${window.location.origin}/news/${
                      reel.slug || reel.id
                    }`}
                    title={reel.title}
                  />
                </div>
              </div>
            );
          })}
        </div>
        <button
          onClick={() => scroll("right")}
          className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white rounded-full p-2 shadow-lg transition-transform transform hover:scale-110 -mr-4"
        >
          <ArrowRightIcon />
        </button>
      </div>
      <ReelPlayerModal
        reel={selectedReel}
        onClose={() => setSelectedReel(null)}
        lang={lang}
      />
    </div>
  );
};

export default ReelsSection;
